mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    id
    title
    description
    type {
      id
      title
    }
    image {
      id
      url(format: HIGH)
    }
    verticalImage {
      id
      url(format: HIGH)
    }
    customFieldValues {
      name
      value
    }
    platformPage {
      id
      title
      path
    }
    createdAt
    updatedAt
  }
}
